export const environment = {
    production: false,
    IS_PAYEMENT_ENABLED: true,
    AppName: 'E-CPPF',
    version: {
        desc: 'E-CPPF',
        number: '1.0',
        date: '08 août 2025'
    },
    BackendUrl: 'http://localhost:8081'
};
